import moment from 'moment';
import 'moment/locale/tr';
import 'normalize.css';
import '@fortawesome/fontawesome-free/css/all.css';
import './src/theme/bulma.scss';

// Set global locale.
moment.locale('tr');

// import './node_modules/bulmaswatch/nuclear/bulmaswatch.scss';
